import { resolveText } from "../../i18n/resolve-text.js";
import { connectingText, startText, stopText } from "../../../i18n/text/cast.js";
import { resolveLabel } from "../utils/resolve-label.js";
import { createState } from "@videojs/store";
import { defaults } from "@videojs/utils/object";
//#region src/core/ui/cast-button/core.ts
var CastButtonCore = class CastButtonCore {
	static defaultProps = {
		label: "",
		disabled: false
	};
	state = createState({
		connection: "disconnected",
		availability: "unsupported",
		disabled: true,
		hidden: true,
		label: ""
	});
	#props = { ...CastButtonCore.defaultProps };
	#media = null;
	constructor(props) {
		if (props) this.setProps(props);
	}
	setProps(props) {
		this.#props = defaults(props, CastButtonCore.defaultProps);
	}
	getLabel(state) {
		const label = resolveLabel(this.#props.label, state);
		if (label) return label;
		if (state.connection === "connected") return stopText;
		if (state.connection === "connecting") return connectingText;
		return startText;
	}
	getAttrs(state) {
		return {
			"aria-label": this.getLabel(state),
			"aria-disabled": state.disabled ? "true" : void 0,
			hidden: state.hidden ? "" : void 0
		};
	}
	setMedia(media) {
		this.#media = media;
	}
	getState() {
		const media = this.#media;
		const availability = !!globalThis.chrome ? media.remotePlaybackAvailability : "unsupported";
		this.state.patch({
			connection: media.remotePlaybackState,
			availability,
			disabled: this.#props.disabled || availability !== "available",
			hidden: availability === "unsupported"
		});
		this.state.patch({ label: resolveText(this.getLabel(this.state.current)) });
		return this.state.current;
	}
	async toggle(media) {
		this.setMedia(media);
		if (this.getState().disabled) return;
		return media.toggleRemotePlayback();
	}
};
//#endregion
export { CastButtonCore };

//# sourceMappingURL=core.js.map